import {PublicDashboardDetailsDto} from "@material-dev/insights-portal-ui-components/lib/api-clients/ShellApiClient";
import {LoadingState} from "../../types";

export interface DashboardState {
  dashboardDetails: PublicDashboardDetailsDto | null;
  loading: LoadingState;

  helpDrawerOpen: boolean;
}

export const initialDashboardState: DashboardState = {
  dashboardDetails: null,
  loading: LoadingState.idle,

  helpDrawerOpen: false,
};
